function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx84037__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.27 53.676c0 4.347 13.43 7.871 29.995 7.871 16.564 0 29.994-3.524 29.994-7.87l2.818-52.25L0 0l5.27 53.676z",
  id: "pfx84037__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v21.574c16.399 0 29.695 3.485 29.695 7.785v43.97C29.695 77.63 16.4 83.616 0 83.616L.058 91H73V0",
  id: "pfx84037__d"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 29)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-27 -24.3)",
  filter: "url(#pfx84037__a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 158.438 -21.603)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E84A32",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.527 4.857)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 5.08 4.235)",
  d: "M2.888 8.864L7.272 -0.394"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 8.187 13.798)",
  d: "M9.914 18.619L6.459 8.977"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 16.403 19.587)",
  d: "M21.112 21.613L11.694 17.561"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 27.242 13.95)",
  d: "M31.353 10.891L23.13 17.01"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 29.865 2.526)",
  d: "M30.517 -2.553L29.212 7.604"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.974 16.332L4 18.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.974 19.332L0.375 19.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.668 23.801L17.502 27.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.668 0.801L30.502 4.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.075 21L33.388 25.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.075 29L35.375 29.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.075 0L21.388 4.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.341 12.426L40.424 13.399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.341 14.426L46.375 14.632"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E84A32",
  cx: 26.875,
  cy: 10.132,
  r: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M63 96.297c6-41-26-55-25.754-77 .245-22 33-24 45-12s19 18 38 41 51-6 35-21-51 9-78 4-9-39 16-25 50 66 24 100-108 12-116-27 24-53 54-44 64 76 129 76",
  stroke: "#E84A32",
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M66 60c0 4.419-13.655 8-30.5 8S5 64.419 5 60c0-4.419 13.655-8 30.5-8S66 55.581 66 60",
  fill: "#544D44"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 6.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx84037__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx84037__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M57.625 25.229c-2.071-3.697-5.626-6.163-9.752-6.76-3.587-.522-7.134.453-10.257 2.82a18.795 18.795 0 0 0-2.376 2.152.606.606 0 0 1-.079.072l-.025.02c-.002 0-.002.002-.003.002-.01.005-.017.01-.024.016l-.009.003-.02.013-.01.005c-.005.004-.01.008-.018.01l-.014.007-.01.005c-.038.018-3.946 1.78-9.84 4.188-2.957 1.209-3.178 3.428-3.516 6.79-.163 1.64-.347 3.476-.902 5.462.72.096 1.926.175 3.214-.077 2.642-.52 4.397-2.157 5.217-4.868a.654.654 0 0 1 .25-.348c.127-.089 3.152-2.135 9.026-.193 1.84.608 3.464.944 4.828 1 1.107.043 1.754-.112 2.042-.21.44-.15.916-.035 1.243.297l7.615 7.695.429.434c1.617-2.104 2.864-4.197 3.707-6.23a14.019 14.019 0 0 0-.716-12.305z",
  fill: "#CAC5B8",
  mask: "url(#pfx84037__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.234 45.218c-.002 0-8.526-8.617-8.526-8.617-.463.15-1.25.309-2.455.26-1.483-.06-3.225-.419-5.18-1.064-2.731-.903-4.734-.845-5.933-.637-.906.155-1.5.419-1.776.563-1.256 3.827-4.04 5.122-6.178 5.532-2.31.443-4.32-.04-4.404-.061a.651.651 0 0 1-.413-.318.65.65 0 0 1-.05-.522c.684-2.133.884-4.141 1.061-5.913.177-1.763.329-3.287.89-4.618.643-1.528 1.733-2.563 3.43-3.256a363.11 363.11 0 0 0 8.937-3.787 18.237 18.237 0 0 0-1.728-1.49c-3.12-2.368-6.67-3.343-10.257-2.821-4.125.6-7.679 3.064-9.751 6.761a14.021 14.021 0 0 0-.715 12.305c1.227 2.963 3.298 6.03 6.155 9.124l1.9-1.922a3.658 3.658 0 0 1 5.204 0 3.747 3.747 0 0 1 1.015 3.307 3.654 3.654 0 0 1 3.271 1.026 3.742 3.742 0 0 1 1.015 3.305 3.635 3.635 0 0 1 3.271 1.028 3.746 3.746 0 0 1 1.015 3.308 3.65 3.65 0 0 1 3.271 1.026 3.754 3.754 0 0 1 .819 4.002l.29.294c.93.938 2.441.938 3.369 0a2.43 2.43 0 0 0 0-3.406l-6.965-7.042a.661.661 0 0 1 0-.928.642.642 0 0 1 .917 0L42.7 57.7c.929.939 2.439.939 3.368 0 .929-.937.929-2.465 0-3.404L39.1 47.253a.665.665 0 0 1 0-.928.644.644 0 0 1 .918 0l6.966 7.041c.93.94 2.44.94 3.368 0 .93-.937.93-2.465 0-3.404l-6.964-7.042a.661.661 0 0 1 0-.928.644.644 0 0 1 .918 0l6.966 7.043a2.366 2.366 0 0 0 3.368 0 2.433 2.433 0 0 0 0-3.406l-.407-.411z",
  fill: "#EBEDE3",
  mask: "url(#pfx84037__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.526 45.665a2.365 2.365 0 0 0-3.367 0l-2.294 2.321a.656.656 0 0 1-.152.154l-.261.263a2.405 2.405 0 0 0-.697 1.702c0 .644.248 1.248.697 1.703.929.939 2.439.939 3.368 0l2.706-2.736a2.43 2.43 0 0 0 0-3.407zm4.287 4.333a2.365 2.365 0 0 0-3.368 0l-2.707 2.736a2.43 2.43 0 0 0 0 3.406c.93.938 2.439.938 3.368 0l2.707-2.738c.929-.937.929-2.465 0-3.404zm4.984 6.036c0-.643-.248-1.248-.698-1.703a2.358 2.358 0 0 0-1.685-.705c-.636 0-1.235.251-1.683.705l-2.707 2.736a2.43 2.43 0 0 0 0 3.406c.93.937 2.439.937 3.368 0l2.707-2.736c.45-.455.698-1.06.698-1.703zm3.588 2.63c.929.938.929 2.466 0 3.405l-2.707 2.736a2.354 2.354 0 0 1-1.683.705 2.358 2.358 0 0 1-1.685-.705 2.427 2.427 0 0 1 0-3.404l2.707-2.738a2.366 2.366 0 0 1 3.368 0z",
  fill: "#CAC5B8",
  mask: "url(#pfx84037__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.3 30.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx84037__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx84037__d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.914 23.849c3.364-2.637 14.24 5.832 24.296 18.916 10.056 13.083 15.481 25.826 12.117 28.462-3.363 2.637-14.24-5.832-24.297-18.916C13.974 39.228 8.55 26.485 11.914 23.849",
  fill: "#544D44",
  mask: "url(#pfx84037__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.417 66.454l-6.09 4.773c3.365-2.637-2.06-15.38-12.116-28.462-10.056-13.083-20.934-21.553-24.297-18.917l6.09-4.772c3.363-2.637 14.241 5.832 24.297 18.916 10.056 13.082 15.48 25.825 12.116 28.462",
  fill: "#CAC5B8",
  mask: "url(#pfx84037__e)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 60)",
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 44.542V12c0 4.372 13.655 7.915 30.5 7.915S61 16.372 61 12v32.542C61 48.914 47.345 55 30.5 55S0 48.914 0 44.542"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8V0c0 4.419 13.655 8 30.5 8S61 4.419 61 0v8c0 4.419-13.655 8-30.5 8S0 12.419 0 8"
})));

function SvgQ1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ1);
export default __webpack_public_path__ + "static/media/q1.109e4e1a.svg";
export { ForwardRef as ReactComponent };